var _radialGradient, _circle, _path, _path2, _radialGradient2, _path3, _radialGradient3, _path4, _radialGradient4, _path5, _circle2, _circle3, _circle4, _circle5, _radialGradient5, _path6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSadButRelievedFace(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 48 48",
    width: "100px",
    height: "100px",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _radialGradient || (_radialGradient = /*#__PURE__*/React.createElement("radialGradient", {
    id: "DmwaMhFq9OAoQrQ1~aLDTa",
    cx: -384,
    cy: 24,
    r: 18,
    fx: -384.095,
    fy: 16.289,
    gradientTransform: "matrix(-1 0 0 1 -360 0)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ffe16e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.629,
    stopColor: "#ffd426"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.72,
    stopColor: "#fdcd23"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.854,
    stopColor: "#f8b919"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#f09c0c"
  }))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 24,
    cy: 24,
    r: 18,
    fill: "url(#DmwaMhFq9OAoQrQ1~aLDTa)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#805b2a",
    d: "M36.457,18.998c-0.827-0.044-1.607-0.148-2.403-0.292c-0.792-0.146-1.578-0.339-2.357-0.584 c-1.551-0.501-3.088-1.233-4.413-2.402c-0.422-0.372-0.462-1.015-0.09-1.437s1.015-0.462,1.437-0.09 c0.029,0.026,0.056,0.052,0.081,0.08l0.006,0.007c0.916,1.013,2.161,1.819,3.517,2.425c1.356,0.598,2.841,1.047,4.309,1.297 l0.024,0.004c0.272,0.047,0.455,0.305,0.409,0.577C36.933,18.836,36.707,19.012,36.457,18.998z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#805b2a",
    d: "M11.457,18.002c1.468-0.251,2.953-0.7,4.309-1.297c1.356-0.606,2.602-1.412,3.517-2.425l0.005-0.006 c0.377-0.417,1.021-0.45,1.438-0.073c0.417,0.377,0.45,1.021,0.073,1.438c-0.026,0.029-0.054,0.056-0.082,0.081 c-1.326,1.169-2.863,1.901-4.413,2.402c-0.779,0.245-1.566,0.439-2.357,0.584c-0.796,0.144-1.577,0.248-2.403,0.292 c-0.276,0.015-0.511-0.197-0.526-0.473c-0.014-0.256,0.168-0.477,0.415-0.519L11.457,18.002z"
  })), _radialGradient2 || (_radialGradient2 = /*#__PURE__*/React.createElement("radialGradient", {
    id: "DmwaMhFq9OAoQrQ1~aLDTb",
    cx: -37.244,
    cy: 3.51,
    r: 3.326,
    gradientTransform: "matrix(.0157 1.116 -3.2952 .1212 36.148 72.85)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.629,
    stopColor: "#ffe16e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.871,
    stopColor: "#ffe16e",
    stopOpacity: 0
  }))), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#DmwaMhFq9OAoQrQ1~aLDTb)",
    d: "M19.17,34.252c0,0,1.116,0.748,4.83,0.748c3.44,0,4.827-0.748,4.827-0.748 s-0.863-1.485-4.827-1.485S19.17,34.252,19.17,34.252z"
  })), _radialGradient3 || (_radialGradient3 = /*#__PURE__*/React.createElement("radialGradient", {
    id: "DmwaMhFq9OAoQrQ1~aLDTc",
    cx: 652.039,
    cy: -936.793,
    r: 8.277,
    gradientTransform: "matrix(-.618 0 0 -.3776 426.964 -320.949)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.284,
    stopColor: "#cc9000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#cc9000",
    stopOpacity: 0
  }))), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#DmwaMhFq9OAoQrQ1~aLDTc)",
    d: "M24,34c3.392,0,4.31,0.609,4.31,0.609S27.43,36,24,36s-4.31-1.391-4.31-1.391S20.608,34,24,34 z"
  })), _radialGradient4 || (_radialGradient4 = /*#__PURE__*/React.createElement("radialGradient", {
    id: "DmwaMhFq9OAoQrQ1~aLDTd",
    cx: -1277.756,
    cy: -651.62,
    r: 15.654,
    gradientTransform: "matrix(.35 0 0 -.1877 471.199 -88.754)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#1c1911"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.999,
    stopColor: "#171714"
  }))), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#DmwaMhFq9OAoQrQ1~aLDTd)",
    d: "M28.701,34.195c0.501,0.276,0.995-0.358,0.608-0.779C28.185,32.194,26.458,31,24,31 s-4.185,1.194-5.309,2.416c-0.387,0.421,0.107,1.055,0.608,0.779C20.45,33.559,22.024,33,24,33S27.55,33.559,28.701,34.195z"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 17,
    cy: 24,
    r: 4,
    fill: "#fff"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 17,
    cy: 24,
    r: 2,
    fill: "#212121"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 31,
    cy: 24,
    r: 4,
    fill: "#fff"
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 31,
    cy: 24,
    r: 2,
    fill: "#212121"
  })), _radialGradient5 || (_radialGradient5 = /*#__PURE__*/React.createElement("radialGradient", {
    id: "DmwaMhFq9OAoQrQ1~aLDTe",
    cx: 39.056,
    cy: 30.479,
    r: 4.596,
    fx: 36.945,
    fy: 30.485,
    gradientTransform: "matrix(0 -1 .8265 0 13.866 69.534)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#b3f1ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.166,
    stopColor: "#9ee4fc"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.509,
    stopColor: "#68c2f3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.996,
    stopColor: "#118ce6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#108ce6"
  }))), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#DmwaMhFq9OAoQrQ1~aLDTe)",
    d: "M42,32c0,1.657-1.343,3-3,3s-3-1.343-3-3c0-2.4,2.4-8,3-8S42,29.6,42,32z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSadButRelievedFace);
export default __webpack_public_path__ + "static/media/sad-but-relieved-face.523040197503676c2ba7402ab9d877a2.svg";
export { ForwardRef as ReactComponent };